import { createHashParams } from '../../utils';
import type { RedirectHashParams } from '../../types/hashParams';

export function useNavigateToPortalUrl() {
  const createPortalUrl = (
    redirectURL: string,
    hashParams: RedirectHashParams
  ) => {
    return `${redirectURL}?${createHashParams(hashParams)}`;
  };

  return {
    createPortalUrl,
  };
}
